/**
 * IBM Confidential OCO Source Materials IBM Business Platform: Cognos Analytics Home
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise divested of
 * its trade secrets, irrespective of what has been deposited with the U.S.
 * Copyright Office
 */
requirejs.config({
	paths: {
		'ca-content': 'js/ca-content',
		'homeBridgeBundle': 'js/ca-content/homeBridgeBundle',
		'contentBridgeBundle': 'js/ca-content/contentBridgeBundle',
		'contentGlassBundle': 'js/ca-content/contentGlassBundle'
	},
	bundles: {

	},
	map: {
		'*': {
		}
	}
});
